module.exports = __webpack_public_path__ + "assets/images/icon-plus.svg?v=2cd749bd";